import { Select } from "Components/Form/Select";
import { useTexts } from "Components/TextContext";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { getBonusOptions } from "../formElementsOptions";
import { CarProductDetailsFormValues } from "../interfaces";

interface Props {
  formProps: FormikProps<CarProductDetailsFormValues>;
  texts: any;
  lang: TextLanguage;
}

export const HaveCarInsurance = (props: Props): React.ReactElement => {
  const { formProps, texts, lang } = props;
  const { getText } = useTexts();

  const label = getText("carform.label.bonushasfrommyself");
  const hint = getText("carform.hint.bonusbefore");

  return (
    <Select
      id="bonus"
      name="bonus"
      label={label}
      hint={hint}
      options={getBonusOptions(texts.bonus.options, lang)}
      error={getError("bonus", formProps)}
      large
    />
  );
};
